import { useState } from 'react';
import axios from 'axios';

const F = '"Geist", system-ui, sans-serif';

export default function AdminLoginPage({ onLogin }: { onLogin: (token: string) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/admin/auth/login', { email: email.trim(), password });
      const token = (data as { token: string }).token;
      localStorage.setItem('corner:admin-token', token);
      onLogin(token);
    } catch (err: unknown) {
      const msg = (err as any)?.response?.data?.error ?? 'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#1A1714', fontFamily: F }}>
      <form onSubmit={handleSubmit} style={{ width: 360, padding: 40, backgroundColor: '#2C2218', borderRadius: 12, border: '1px solid #3D3226' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
          <svg width="28" height="28" viewBox="0 0 256 256" fill="none" style={{ flexShrink: 0 }}>
            <defs>
              <linearGradient id="admin-login-grad" x1="42" y1="38.5" x2="207" y2="209" gradientUnits="userSpaceOnUse">
                <stop stopColor="#D46A3A" />
                <stop offset="1" stopColor="#8B3A10" />
              </linearGradient>
            </defs>
            <path d="M236 152V32C236 25.373 230.627 20 224 20H32C25.373 20 20 25.373 20 32L20 224C20 230.627 25.373 236 32 236H152" stroke="url(#admin-login-grad)" strokeWidth="40" strokeLinecap="round" />
          </svg>
          <span style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>Corner Admin</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ fontSize: 13, color: '#8B7D6B', display: 'block', marginBottom: 6 }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #3D3226', backgroundColor: '#1A1714', color: '#FDFCFB', fontSize: 14, fontFamily: F, outline: 'none', boxSizing: 'border-box' }}
            />
          </div>
          <div>
            <label style={{ fontSize: 13, color: '#8B7D6B', display: 'block', marginBottom: 6 }}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ width: '100%', padding: '10px 40px 10px 12px', borderRadius: 8, border: '1px solid #3D3226', backgroundColor: '#1A1714', color: '#FDFCFB', fontSize: 14, fontFamily: F, outline: 'none', boxSizing: 'border-box' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center' }}
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8B7D6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8B7D6B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ fontSize: 13, color: '#D94545', backgroundColor: 'rgba(217,69,69,0.08)', padding: '8px 12px', borderRadius: 6 }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', backgroundColor: '#D46A3A', color: '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'wait' : 'pointer', fontFamily: F, opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Signing in...' : 'Sign in to Admin'}
          </button>
        </div>
      </form>
    </div>
  );
}
